import { render, staticRenderFns } from "./TaskEditor.vue?vue&type=template&id=0e24ccab&scoped=true&"
import script from "./TaskEditor.vue?vue&type=script&lang=ts&"
export * from "./TaskEditor.vue?vue&type=script&lang=ts&"
import style0 from "./TaskEditor.vue?vue&type=style&index=0&id=0e24ccab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e24ccab",
  null
  
)

export default component.exports